exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "input.search {\n  text-align: left; }\n\ntable.edit-pricing-table {\n  margin-left: 0;\n  margin-right: 0;\n  width: 100%; }\n  table.edit-pricing-table td {\n    opacity: 1; }\n\n.edit-pricing-button-wrapper {\n  display: flex; }\n", ""]);

